import { createSlice } from "@reduxjs/toolkit";
import loginApi from "../../../rtk-apis/authentication/login";

const initialState = {
    accessToken: "",
    userDetails: {},
    status: "",
    result: {},
    msg: "",
    loading: false,
    error: "",
};

const loginSlice = createSlice({
    name: "loginSlice",
    initialState,
    reducers: {
        closeModal (state:any) { state.status = ""; }
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginApi.pending, (state) => {
                state.loading = true;
                state.status = 'LOADING'
            })
            .addCase(loginApi.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.accessToken = payload.accessToken;
                state.userDetails = payload.userDetails;
                state.status = payload.status;
                state.result = payload.result;
                state.msg = payload.msg;
            })
            .addCase(loginApi.rejected, (state, { payload }) => {
                state.result = payload;
                state.loading = false;
                state.status = 'ERROR'
            });
    },
});

export default loginSlice.reducer;
export const { closeModal } = loginSlice.actions;
